import React from "react";
import { Link } from "react-router-dom";
import NotificationIcon from "../NotificationIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const DashboardCardItem = ({
  path,
  text,
  description,
  icon,
  notification,
  type,
  horizontal,
  forFormula,
}) => {
  return (
    <div
      className={
        forFormula ? "col-md-12" : horizontal ? "col-md-4" : "col-md-3"
      }
    >
      <Link to={path}>
        <div className={horizontal ? "dash-card-horizontal" : "dash-card"}>
          <div className="heading">
            <div className="icon">
              {type === "image" ? (
                <img src={icon} alt="" />
              ) : (
                <FontAwesomeIcon icon={icon} size="lg" />
              )}
            </div>
            <div className="title">{text}</div>
            {notification > 0 && (
              <div className="noti">
                <NotificationIcon count={notification} />
              </div>
            )}
          </div>

          <div className="description">{description}</div>
        </div>
      </Link>
    </div>
  );
};

export default DashboardCardItem;
